import React from 'react'
import classNames from 'classnames'
import { useRouter } from 'next/router'
import Script from 'next/script'
import useSiteAssets from '@/services/hooks/useSiteAssets'
import ZendeskLauncher from './ZendeskLauncher'

const investFlowRoutesMatch =
  /\/\w+\/(invest)\w*\/\[(slug|investmentId)\](\/\w+)*/

const Zendesk = () => {
  const siteAssets = useSiteAssets()
  const router = useRouter()

  if (!siteAssets?.zendeskKey) {
    return null
  }

  return (
    <>
      {/* Hide default widget button */}
      <style>{`iframe#launcher { display: none; }`}</style>

      {/* Load zendesk script */}
      <Script
        strategy="afterInteractive"
        id="ze-snippet"
        src={`https://static.zdassets.com/ekr/snippet.js?key=${siteAssets.zendeskKey}`}
      />

      {/* Render custom widget button */}
      <ZendeskLauncher
        className={classNames({
          'fixed bottom-[var(--zendesk-bottom-position)] right-4 z-[9998] h-[48px] w-[48px] rounded-full md:w-auto md:px-5 lg:bottom-4':
            true,
          'hidden md:block': investFlowRoutesMatch.test(router.route),
        })}
        text="Help"
      />
    </>
  )
}

export default Zendesk
